module.exports = __webpack_public_path__ + "images/category_lp/camera/new/main-bg-sp_26597242e71d1505a62ad818a3d302be.png";